import { NgModule } from '@angular/core';
import { NgxDynamicTableComponent } from './ngx-dynamic-table.component';



@NgModule({
  declarations: [
    NgxDynamicTableComponent
  ],
  imports: [
  ],
  exports: [
    NgxDynamicTableComponent
  ]
})
export class NgxDynamicTableModule { }
